import { createContext, useContext } from "react";

/**
 * FinancePodBills owns the load; the Actions cell needs the same refetch after Create Bill
 * so the marked line leaves the unbilled table without a manual Get Report.
 */
export const PodBillsRefreshContext = createContext<(() => void) | null>(null);

export function usePodBillsRefresh(): () => void {
  return useContext(PodBillsRefreshContext) ?? (() => {});
}
